"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconParcelArrowOutline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconParcelArrowOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, (0, _extends2.default)({
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#eliaal8fva)"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.158 1.026a.5.5 0 0 0-.316 0l-10.5 3.5A.5.5 0 0 0 0 5v13.5a.5.5 0 0 0 .322.467l10.5 4a.5.5 0 0 0 .356 0l5.25-2a.5.5 0 1 0-.356-.934L11.5 21.774V8.86L21 5.694V10a.5.5 0 1 0 1 0V5a.5.5 0 0 0-.342-.474l-10.5-3.5zM10.5 8.86v12.915L1 18.154V5.694l9.5 3.166zm.5-.887L2.081 5 11 2.027 19.919 5 11 7.973zm8.854 3.173A.5.5 0 0 0 19 11.5V13h-4.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5H19v1.5a.5.5 0 0 0 .854.354l4-4a.5.5 0 0 0 0-.708l-4-4zM20 13.5v-.793l2.793 2.793L20 18.293V17.5a.5.5 0 0 0-.5-.5H15v-3h4.5a.5.5 0 0 0 .5-.5z",
  fill: "#000"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "eliaal8fva"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
exports.IconParcelArrowOutline = IconParcelArrowOutline;
//# sourceMappingURL=IconParcelArrowOutline.js.map